module.exports = __webpack_public_path__ + "img/588x310-01.fc1c8051.png";